var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"online-details row"},[(_vm.loading_message.length > 0)?_c('LoadingScreen',{attrs:{"header":_vm.getText('TransactionLoadingHeader'),"message":_vm.loading_message}}):_vm._e(),_vm._v("\n\n\tTest\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }